export const INVALID_PHONE_NUMBER = "Phone number invalid\n\nPlease try again.";
export const GENERIC_ERROR =
  "Something went wrong.\n\nTry again, or contact the developer";
export const ERROR_CREATE_USER =
  "We were unable to create an account for you at this time.\n\nPlease try again later.";
export const UNEXPECTED_ERROR =
  "An unexpected error occured. Please contact the developer";
export const ERROR_SENDING_SMS =
  "We were unable to send the token.\n\nPlease try again later.";
export const ERROR_FINDING_USER = "We were unable to find your account";
export const ERROR_TOKEN_ATTEMPTS =
  "You have tried to log in too many times. \n\nTry again in 24 hours.";
